import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import Autocomplete from 'react-autocomplete';


import { cdn } from '../../helpers/cdn';
import { api } from '../../../services/index';

const debounceWait = 500;

class SearchChannels extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			searchValue: '',
			isSearching: false,
			searchError: false,
			searchResults: []
		}

		this.searchUsers = _.debounce(this.searchUsers.bind(this), debounceWait);
		this.onSearchChange = this.onSearchChange.bind(this);
		this.renderItem = this.renderItem.bind(this);
		this.renderItems = this.renderItems.bind(this);
		this.selectChannel = this.selectChannel.bind(this);
	}

	searchUsers(text) {
		this.setState(() => ({ isSearching: true, searchResults: [] }));

		return api.getUsers(text)
			.then(result => this.setState({
				searchResults: result.data,
				isSearching: false
			}))
			.catch(() => this.setState({ isSearching: false, searchError: true }))
	}

	onSearchChange(event, value) {
		this.setState({ searchValue: value });
		this.searchUsers(this.state.searchValue)
	}

	selectChannel(channel) {
		const { history } = this.props;
		history.push(`/c/${channel}`);
	}

	renderItems(items) {
		const { classes } = this.props;

		return <div className={classes.autocompleteWrap} children={items}></div>;
	}
	renderItem(item, isHighlighted) {
		const { classes } = this.props;
		const classList = classNames({
			[classes.autocompleteItem]: true,
			[classes.autocompleteItemHighlighted]: isHighlighted
		});

		return (<div className={classList} key={item}>{item}</div>
		)
	}

	render() {
		const { classes } = this.props;
		return (
			<form className={classes.searchChannelsForm} onSubmit={(e) => e.preventDefault()}>
				{/* <span className={classes.isSearching}></span> */}
				<Autocomplete
					value={this.state.searchValue}
					items={this.state.searchResults}
					getItemValue={(item) => item}
					onSelect={this.selectChannel}
					onChange={this.onSearchChange}
					renderMenu={this.renderItems}
					renderItem={this.renderItem}
					inputProps={{ placeholder: 'Look up a Twitch user' }}
					wrapperStyle={{ width: '100%' }} />
				<button className={classes.submitButton}>
					<img src={cdn('icons/search-channel.svg')} alt="Search" />
				</button>
			</form>
		)
	}

}

const styles = (theme) => ({
	searchChannelsForm: {
		width: '100%',
		position: 'relative',
		marginBottom: theme.spacing,
		'& input': {
			width: '100%',
			height: '36px',
			border: `1px ${theme.palette.border} solid`,
			borderRadius: 3,
			paddingLeft: theme.spacing * 1.5,
			paddingRight: theme.spacing * 5,
		}
	},
	submitButton: {
		position: 'absolute',
		right: 0,
		top: 0,
		height: '100%',
		width: 40,
		border: 'none',
		background: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		userSelect: 'none'
	},

	isSearching: {
		position: 'absolute',
		width: 30,
		height: 8,
		top: -8,
		left: 0,
		animation: 'loadingAnimation .5s ease-in-out infinite',
		backgroundColor: theme.palette.primary
	},
	autocompleteWrap: {
		position: 'absolute',
		zIndex: 3,
		left: 0,
		top: 36,
		width: '100%',
		padding: `${theme.spacing} 0`,
		minHeight: 120,
		maxHeight: 320,
		overflowY: 'scroll',
		backgroundColor: theme.backgrounds.card,
		boxShadow: theme.boxShadowDp2
	},
	autocompleteItem: {
		...theme.typography.link,
		padding: `${theme.spacing}px ${theme.spacing}px`,
		textTransform: 'uppercase',
		borderBottom: `1px ${theme.palette.border} solid`,
		cursor: 'pointer',
	},
	autocompleteItemHighlighted: {
		backgroundColor: theme.palette.highlight
	}
});

export default withRouter(injectSheet(styles)(SearchChannels));


// WEBPACK FOOTER //
// ./src/app/components/channelSelector/SearchChannels.js